import React from "react";
import { NakiNigunImportBatchListTemplate } from "themes/administration/naki-nigun-import/pages";
import { NakiNigunImportBatchListViewStore } from "administration/naki-nigun-import/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiNigunImportBatchListViewStore(rootStore, componentProps),
    "nakiNigunImportBatchListViewStore"
)
class NakiNigunImportBatchList extends React.Component {
    render() {
        return <NakiNigunImportBatchListTemplate {...this.props} />;
    }
}

export default NakiNigunImportBatchList;
